require('../../jsy_do_widokow_z_salami/sale/balkon3/row1.js');
require('../../jsy_do_widokow_z_salami/sale/balkon3/row2.js');